import { countryBingoIdQuery } from '@/shared/graphql/gateway/queries';
import { useConfigStore } from '@/shared/pinia/modules/config';
import { apolloClientInit } from '@/shared/utils/apollo-client';
import { getMarketCountryCode } from '@/shared/utils/country';

export type BingoStoreContext = {
  storeId: string | null;
  lang: string;
};

export const fetchBingoId = async (
  countryCode: string
): Promise<string | null> => {
  const apolloClient = apolloClientInit({
    graphqlHost: import.meta.env.VITE_HOBBII_GATEWAY
  });
  const { data } = await apolloClient.query({
    query: countryBingoIdQuery,
    variables: {
      countryConfigInput: {
        country_code: countryCode.toUpperCase()
      }
    }
  });

  return data?.countryConfigs?.[0]?.bingoId ?? null;
};

export const getBingoStoreContext = async (): Promise<BingoStoreContext> => {
  const { language } = useConfigStore();

  try {
    return {
      storeId: await fetchBingoId(getMarketCountryCode()),
      lang: language
    };
  } catch (thrown) {
    console.error('Could not resolve the bingo store id', thrown);
    return { storeId: null, lang: language };
  }
};
